export default "<a class=\"google-play\" target=\"_blank\" data-bind=\"attr: { href: playStoreURL }\">\n  <div></div>\n</a>\n";